import { render, staticRenderFns } from "./RfiDialog.vue?vue&type=template&id=2293a264&scoped=true"
import script from "./RfiDialog.vue?vue&type=script&lang=js"
export * from "./RfiDialog.vue?vue&type=script&lang=js"
import style0 from "./RfiDialog.vue?vue&type=style&index=0&id=2293a264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293a264",
  null
  
)

export default component.exports